import { useEffect, useState } from "react"

/**
 * @param query
 * @returns
 * @public
 */
export const useMediaQuery = (query: string): boolean => {
	const getMatches = (query: string): boolean => {
		return window.matchMedia(query).matches
	}

	const [matches, setMatches] = useState<boolean>(() => {
		return getMatches(query)
	})

	function handleChange() {
		setMatches(getMatches(query))
	}

	useEffect(() => {
		const matchMedia = window.matchMedia(query)

		handleChange()

		matchMedia.addEventListener("change", handleChange)

		return () => {
			matchMedia.removeEventListener("change", handleChange)
		}
	}, [query])

	return matches
}
